export default __webpack_public_path__ + "static/media/ivancik.442b4747.jpg";